import { DialectSdkError } from '../sdk/errors';
export class DialectCloudError extends DialectSdkError {
}
export class DialectCloudUnreachableError extends DialectCloudError {
    constructor(details) {
        super(DialectCloudUnreachableError.name, 'Lost connection to Dialect Cloud', 'Having problems reaching Dialect Cloud. Please try again later.', details);
    }
}
//# sourceMappingURL=errors.js.map